import { resetFilters, setEtaFilter, setInitialFilters, setProductSortingValue, updateFilters } from '../../ducks';

export const FILTERS_SYNC_ACTIONS_GROUP = [setInitialFilters, updateFilters, resetFilters, setEtaFilter, setProductSortingValue];
export const PRODUCTS_RELOAD_ACTIONS_GROUP = [updateFilters, resetFilters, setEtaFilter, setProductSortingValue];
